import { computed } from 'vue';
import { useUserStore } from '@/store/userStore';
import { useCashAccountsStore } from '@/store/cashAccountsStore';
import { useContextSwitchStore } from '@/store/contextSwitchStore';
import { useEntitlementsStore, EntitlementAction } from '@/store/entitlementsStore';

export default () => {
  const userStore = useUserStore();
  const entitlementsStore = useEntitlementsStore();
  const cashAccountsStore = useCashAccountsStore();
  const contextSwitchStore = useContextSwitchStore();

  const isEntitlementsLoading = computed(() => entitlementsStore.isLoading);

  function isEntitledToCaptureOnSelectedCashAccount(): boolean | null {
    if (userStore.isPotatoOnly) {
      return false;
    }
    if (contextSwitchStore.isPrivateContext) {
      return !!cashAccountsStore.selectedCashAccountUid;
    } else {
      // If entitlements are still loading, return null instead of false
      if (isEntitlementsLoading.value) {
        return null;
      }
      return entitlementsStore.isEntitledToEntity(
        EntitlementAction.Capture,
        cashAccountsStore.selectedCashAccountUid ?? ''
      );
    }
  }

  function canCreatePaymentOnSelectedCashAccount(): boolean | null {
    const isEntitledToCapture = isEntitledToCaptureOnSelectedCashAccount();

    // If entitlements are loading (null), return null instead of false
    if (isEntitledToCapture === null) {
      return null;
    }

    // Proceed with the regular check if entitlement is not null
    if (!isEntitledToCapture) {
      return false;
    }

    return cashAccountsStore.getCurrentCashAccount?.status === 'active';
  }

  return {
    isEntitledToCaptureOnSelectedCashAccount,
    canCreatePaymentOnSelectedCashAccount,
    isEntitlementsLoading
  };
};
